export default function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_isString.js
// module id = 134
// module chunks = 1